"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userAgentMiddleware = void 0;
const userAgentMiddleware = (options) => ({
    onRequest({ request }) {
        if (!request.headers.has('User-Agent')) {
            request.headers.set('User-Agent', `${options.service}/${options.version}`);
        }
        return request;
    },
});
exports.userAgentMiddleware = userAgentMiddleware;
